module.exports = __webpack_public_path__ + "static/media/cleo-tablet-738x57.40d5af93.webp";